import React,{useEffect, useState} from 'react';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import { Grid,Box,Typography,Button,Tooltip } from '@mui/material';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import {useGetAllPersonPictureByTenantId} from '../../../AllTenantOkrs/Hooks/index';
import { useSelector,useDispatch } from 'react-redux';
// import { setOkrDeleteStateR } from '../../OKRManageSlice/OKRManageSlice';
// import EditIcon from '@mui/icons-material/Edit';
// import LikeIcon from '@mui/icons-material/Favorite';
import "../../../CompanyManagment/Copmonents/Like/Like.css";
// import { from } from 'stylis';
import PersonKrDetails from '../PersonKrDetails/PersonKrDetails';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
const PrsCart = (props:any) => {
  // const dispatch=useDispatch();
  // const deleteOkrState=useSelector((state:any)=>state.okrManage.okrDeleteData);
  // const{mutate:likeKr,data:likeData}=useLikeKr()
  // const{mutate:disLikeKr,data:disLikeData}=useDisLikeKr()
  const[showKrDetails,setShowKrDetails]=useState<Boolean>(false);
  // const userId=useSelector((state:any)=>state.loign.userInfo.userId);
  const tenantId=useSelector((state:any)=>state.meetings.profileTenantId);
  const{data:personPicture}=useGetAllPersonPictureByTenantId(tenantId);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  // const [activeBtn, setActiveBtn] = useState<string>("none");
  // const lDeleteSuccess=()=>{
  //   setShowKrDetails(false)
  // }

//   const afterSuccessDelete=()=>{
//     setTimeout(() => {
//       dispatch(setOkrDeleteStateR(null))
//     }, 3000);
//   }
  // const{mutate:callDeleteKr,data:deleteData,isSuccess}=useDeleteKr()
  let{item
    // ,setKrId,setShowEditKr,setAddKrState,setShowToastMessage
  }=props;
  let{id,name,roleName,firstLogin,lastLogin}:any=item;
  // const [likec, setLikeCount] = useState<number>(likeCount);

const initialShowDet=()=>{
  setShowKrDetails(true);
}

// const initialEditKr=()=>{
//   setKrId(id);
//   setShowEditKr(true);
// }

// const initialDeleteKr=()=>{
//   let deleteBody={
//     deletedId:id,
//     userId:userId,
//     tenantId:tenantId
// }

// callDeleteKr(deleteBody)
// }

// useEffect(() => {
      
//   if (deleteOkrState) {
//     setShowToastMessage(true);
//     setAddKrState(deleteOkrState?.data)
//   }
// }, [deleteOkrState])

// useEffect(() => {
  
//   setTimeout(() => {
//     dispatch(setOkrDeleteStateR(null))
// }, 3000);

// }, [deleteOkrState])


// const initialLikeKr=()=>{
//   let deleteBody={
//   keyResultId:id,
//   tenantId:tenantId
//   }
//   likeKr(deleteBody)
//   }

  // const initialDisLikeKr=()=>{
  //   let deleteBody={
  //   keyResultId:id,
  //   tenantId:tenantId
  //   }
  //   disLikeKr(deleteBody)
  //   }

    // useEffect(() => {
    //   if (item) {
    //     setLikeCount(likeCount)
    //     if (liked) {
    //       setActiveBtn("like");
    //     }
    //   }
    // }, likeCount)

    // const handleReactionClick = (reaction: string): void => {
    //   if (activeBtn === "none") {
    //     // if (reaction === "dislike") {
    //     //   setdisLikeCount(dislikeCount + 1);
    //     //   setActiveBtn("disLike");
    //     // } else
    //      if (reaction === "like") {
    //       setLikeCount(likec + 1);
    //       setActiveBtn("like");
    //       initialLikeKr();
    //     }
    //   } else if (activeBtn === reaction) {
    //     // if (reaction === "dislike") {
    //     //   setdisLikeCount(dislikeCount - 1);
    //     // } else 
    //     if (reaction === "like") {
    //       setLikeCount(likec - 1);
    //       initialDisLikeKr();
    //     }
    //     setActiveBtn("none");
    //   } 
    //   else if (activeBtn !== reaction) {
    //     // if (reaction === "dislike") {
    //     //   setdisLikeCount(dislikeCount + 1);
    //     //   setLikeCount(likeCount - 1);
    //     //   setActiveBtn("dislike");
    //     // } else 
    //     if (reaction === "like") {
    //       // setdisLikeCount(dislikeCount + 1);
    //       // setdisLikeCount(dislikeCount - 1);
    //       setActiveBtn("like");
    //     }
    //   }
    // };    

  return (
    < >
             <Grid container   py={1} boxShadow={4} borderRadius={3}  >
            
            <Grid item xs={12}  >
           <Grid container p={1} alignItems={'center'} >
           <Grid item xs={12} sm={10}  >
            
         <Box display={'flex'} flexDirection={'row'} alignItems={'center'} textAlign={'center'} justifyContent={'start'} width={'100%'}>
  
            <Box  minHeight={'30px'} >
              {
                <img src={
                  personPicture !== null && personPicture !== undefined &&
                  personPicture.filter((x:any)=>x.personId === id)[0] !== null &&
                  personPicture.filter((x:any)=>x.personId === id)[0]!== undefined
                  ?
                  personPicture.filter((x:any)=>x.personId === id)[0].pictureBase64String
                  :''
                } width={'28px'} style={{borderRadius:'50%'}} />
              }
            </Box>
            <Typography px={0.5} fontSize={'0.8rem'} fontWeight={700}  >{name}</Typography>
          </Box>
            </Grid>
           </Grid>
            </Grid>
            
            <Grid container p={1} >
            <Grid item xs={12}  sm={12} >
            <Box display={'flex'} justifyContent={'start'}  >
             <Typography variant='body2' fontWeight={700} >نقش : </Typography>
             <Typography variant='body2' fontWeight={500}  >
                 {
                    roleName
                 }
                </Typography>
            </Box>
            </Grid>
            <Grid item xs={12}  sm={12} >
            <Box display={'flex'} justifyContent={'start'}  >
             <Typography variant='body2' fontWeight={700} > اولین ورود : </Typography>
             <Typography variant='body2' fontWeight={500}  >
                 {
                    firstLogin
                 }
                </Typography>
            </Box>
            </Grid>

            <Grid item xs={12}  sm={12} >
            <Box display={'flex'} justifyContent={'start'}  >
             <Typography variant='body2' fontWeight={700} >آخرین ورود  : </Typography>
             <Typography variant='body2' fontWeight={500}  >
                 {
                    lastLogin
                 }
                </Typography>
            </Box>
            </Grid>
            </Grid>

            <Grid xs={12} sm={12} >
              <Box width={'100%'} 
                           display={'flex'}
                           justifyContent={'end'} >
            <Box width={'171px'} 
            height={'43px'}
             p={1}
             display={'flex'}
             flexDirection={'row-reverse'}
             justifyContent={'end'}  > 
            <DyButton  
                caption={'مشاهده نتایج کلیدی '}
                onClick={initialShowDet}
                disbled={false}
                variant={'contained'}
                type={'button'}
                bgColor={'#00387C'}
                />
                </Box>
            </Box>
            </Grid>
             </Grid>
             <Box marginTop={3}> </Box>
             {
                showKrDetails && <ModalLyt 
                showModal={showKrDetails} 
                setShowModal={setShowKrDetails}
                title={'نمایش اطلاعات '}
                width={isMobile ? '350px' : '1300px'} 

                 >
                  <PersonKrDetails personId={id}   /> 
                </ModalLyt>
             }
        </>
  )
}

export default PrsCart